<template>
  <div class="bg-white pa-6">
    <div class="d-flex justify-space-between mb-6 align-center">
      <h4 class="title">Revenue</h4>
      <div class="d-flex purple--text">
        <div class="btn-graph pa-2 mr-2">D</div>
        <div class="btn-graph pa-2 mr-2">W</div>
        <div class="btn-graph active pa-2 mr-2">M</div>
        <div class="btn-graph pa-2 mr-2">Y</div>
      </div>
    </div>
    <canvas id="myChart"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";
export default {
  mounted() {
    this.$nextTick(() => {
      let ctx = document.getElementById("myChart").getContext("2d");
      var myChart = new Chart(ctx, {
        type: "bar",
        data: {
          datasets: [
            {
              label: "Bar Dataset",
              data: [
                78000,
                90000,
                70000,
                90000,
                78000,
                65000,
                98000,
                79000,
                97000,
                78000,
                63000,
                84000,
                88000,
                82000,
                87000
              ],
              barThickness: 6,
              backgroundColor: "#38C976"
            },
            {
              label: "Line Dataset",
              data: [
                40000,
                23000,
                60000,
                60000,
                23000,
                50000,
                38000,
                60000,
                63000,
                40000,
                43000,
                64000,
                60000,
                80000,
                98000
              ],

              // Changes this dataset to become a line
              type: "line",
              borderColor: "#FDC132",
              fill: false,
              borderDash: [5, 6],
              borderWidth: 2
            }
          ],
          labels: [
            "02",
            "04",
            "06",
            "08",
            "10",
            "12",
            "14",
            "16",
            "18",
            "20",
            "22",
            "24",
            "26",
            "28",
            "30"
          ]
        },
        options: {
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  fontColor: "#C0C7CE"
                },
                gridLines: {
                  display: false,
                  offsetGridLines: false,
                  borderDash: [5, 8]
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  fontColor: "#C0C7CE"
                },
                gridLines: {
                  offsetGridLines: false,
                  borderDash: [5, 8]
                }
              }
            ]
          }
        }
      });
    });
  },
  data() {
    return {
      data: {
        "2018-05-13": 640,
        "2018-05-14": 200,
        "2018-05-15": 250,
        "2018-05-16": 350,
        "2018-05-17": 200,
        "2018-05-18": 670,
        "2018-05-19": 600,
        "2018-05-20": 800
      }
    };
  }
};
</script>

<style>
.chart-card {
  border-radius: 3px;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  box-shadow: none !important;
  background-color: transparent;
}
.bg-white {
  background: #fff;
}
.btn-graph {
  font-size: 17px;
  line-height: 20px;
  color: #7557e5 !important;
  font-family: Gotham-Medium;
  font-style: normal;
  font-weight: normal;
}
.btn-graph.active {
  color: #eb67d0 !important;
  background: #f0edfb;
  border-radius: 5px;
}
.title {
  font-family: Gotham-Medium;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  color: #3d4857;
}
</style>
